export const showOrHide = (config, getValue) => {
    if (config === true) return true
    if (Array.isArray(config) && config?.length) {
        for (let i = 0; i < config.length; i++) {
            let item = config[i];
            let value = getValue(item.field.key);
            let optionValues = item.option.map(opt => opt.key);
            if (item.operate === "or") {
                if (method(item, value, optionValues)) {
                    return true
                }
            } else {
                if (!method(item, value, optionValues)) {
                    return false
                }
            }
        }
        return !config.some(item => item.operate === "or");
    }
    return false
}
const method = (item, value, optionValues) => {
    switch (item.method) {
        case "greater": // 大于
            return optionValues.some(optVal => value > optVal);
        case "less": // 小于
            return optionValues.some(optVal => value < optVal);
        case "unequal": // 不等于
            return !optionValues.includes(value);
        case "equal": // 等于
            return optionValues.includes(value);
        case "notNull": // 不为空
            return !!value;
        case "includes": // 包含
            return value && optionValues.some(optVal => value.includes(optVal))
        default:
            return optionValues.includes(value);
    }
}